
import { RefreshCw } from "lucide-react";
import { FileListItem } from "./FileListItem";
import type { FileObject } from "@supabase/storage-js";

interface FileListProps {
  files: FileObject[];
  loading: boolean;
  searchQuery: string;
  selectedFile: FileObject | null;
  onFileClick: (file: FileObject) => void;
  onPreview: (file: FileObject) => void;
  onDownload: (file: FileObject) => void;
  onDelete?: (file: FileObject) => void;
  allowDelete?: boolean;
}

export const FileList = ({
  files,
  loading,
  searchQuery,
  selectedFile,
  onFileClick,
  onPreview,
  onDownload,
  onDelete,
  allowDelete = false,
}: FileListProps) => {
  if (loading) {
    return (
      <div className="border rounded-lg max-h-96 overflow-y-auto">
        <div className="flex items-center justify-center py-8">
          <RefreshCw className="h-6 w-6 animate-spin" />
          <span className="ml-2">Loading files...</span>
        </div>
      </div>
    );
  }

  if (files.length === 0) {
    return (
      <div className="border rounded-lg max-h-96 overflow-y-auto">
        <div className="text-center py-8 text-gray-500">
          {searchQuery ? 'No files match your search' : 'No files found in this bucket'}
        </div>
      </div>
    );
  }

  return (
    <div className="border rounded-lg max-h-96 overflow-y-auto">
      <div className="divide-y">
        {files.map((file) => (
          <FileListItem
            key={file.name}
            file={file}
            isSelected={selectedFile?.name === file.name}
            onClick={onFileClick}
            onPreview={onPreview}
            onDownload={onDownload}
            onDelete={onDelete}
            allowDelete={allowDelete}
          />
        ))}
      </div>
    </div>
  );
};
